import * as React from 'react';
import cn from 'clsx';
const throttle = require('lodash.throttle');
import * as styles from './styles.css';

import { Button } from '@cian/ui-kit';

import { trackLeaveClick } from '../../analytics';

export interface IStickBottomProps {
  feedbackTopPosition: number;
  feedbackHeight: number;
  isVisible: boolean;

  setVisibleStickBottom(visible: boolean): void;
  scrollToFeedback(): void;
}

export class StickBottom extends React.Component<IStickBottomProps, {}> {
  public componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    const { isVisible } = this.props;

    return (
      <div className={cn(styles['container'], isVisible && styles['visible'])}>
        <Button
          size="M"
          theme="fill_primary"
          onClick={() => {
            trackLeaveClick();
            this.props.scrollToFeedback();
          }}
        >
          Оставить заявку
        </Button>
      </div>
    );
  }

  private scrollHandler = () => {
    const { isVisible, feedbackTopPosition, feedbackHeight } = this.props;

    /**
     * Скрытвает стик подвал, если проскролили до середины формы обратной связи.
     */
    if (window.scrollY + window.innerHeight >= feedbackTopPosition + feedbackHeight / 2) {
      if (isVisible) {
        this.props.setVisibleStickBottom(false);
      }
    }
  };

  private handleScroll = throttle(this.scrollHandler, 150);
}
